import "./DesktopDashboard.css";
import { useEffect, useState } from "react";
import { authApi } from "../../../api";

const defaultInfo = [
  { label: "Pub ID", value: "23104" },
  { label: "Account Code", value: "E2806e7a41f0dbd707eeba0718679e6c" },
  { label: "Name", value: "Publisher Demo" },
  { label: "Email Address", value: "publisher@givvy.net" },
  { label: "Notifications Email Address", value: "publisher@givvy.net" },
  { label: "Company", value: "Givvy LTD" },
  { label: "Address", value: "" },
  { label: "City", value: "" },
  { label: "Country", value: "Bulgaria" },
  { label: "Date Registered", value: "March 19, 2020" },
  { label: "Privacy system integration key", value: "4ee02e40d326f7699c3feb9ff2fccc4d" }
];

export default function AccountInfo({ info = defaultInfo, user, onUpdate }) {
  const [form, setForm] = useState({
    email: user?.email || '',
    contactPerson: user?.contactPerson || '',
    companyName: user?.companyName || '',
    address: user?.address || '',
    country: user?.country || '',
    city: user?.city || '',
    phone: user?.phone || '',
    appWebsiteLink: user?.appWebsiteLink || '',
    notificationsEmail: user?.notificationsEmail || ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current: '',
    next: '',
    confirm: ''
  });
  const [passwordSaving, setPasswordSaving] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');

  useEffect(() => {
    setForm({
      email: user?.email || '',
      contactPerson: user?.contactPerson || '',
      companyName: user?.companyName || '',
      address: user?.address || '',
      country: user?.country || '',
      city: user?.city || '',
      phone: user?.phone || '',
      appWebsiteLink: user?.appWebsiteLink || '',
      notificationsEmail: user?.notificationsEmail || ''
    });
  }, [user]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const res = await authApi.updateProfile({
        email: form.email,
        contactPerson: form.contactPerson,
        companyName: form.companyName,
        address: form.address,
        country: form.country,
        city: form.city,
        phone: form.phone,
        appWebsiteLink: form.appWebsiteLink,
        notificationsEmail: form.notificationsEmail
      });
      const nextUser = res?.result?.user || res?.user;
      if (nextUser && onUpdate) {
        onUpdate(nextUser);
        if (typeof window !== 'undefined') {
          window.localStorage.setItem('auth_user', JSON.stringify(nextUser));
        }
      }
      setSuccess('Saved');
    } catch (err) {
      setError(err?.data?.statusText || err?.message || 'Failed to update');
    } finally {
      setSaving(false);
    }
  }

  function resetPasswordState() {
    setPasswordForm({ current: '', next: '', confirm: '' });
    setPasswordError('');
    setPasswordSuccess('');
  }

  async function handlePasswordSubmit(e) {
    e.preventDefault();
    if (passwordSaving) return;
    setPasswordError('');
    setPasswordSuccess('');

    if (!passwordForm.current || !passwordForm.next || !passwordForm.confirm) {
      setPasswordError('All password fields are required');
      return;
    }

    if (passwordForm.next !== passwordForm.confirm) {
      setPasswordError('New passwords do not match');
      return;
    }

    if (!user?.email) {
      setPasswordError('Missing account email');
      return;
    }

    setPasswordSaving(true);
    try {
      await authApi.changePassword({
        email: user.email,
        oldPassword: passwordForm.current,
        newPassword: passwordForm.next
      });
      setPasswordSuccess('Password updated');
      setPasswordForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      setPasswordError(err?.data?.statusText || err?.message || 'Failed to update password');
    } finally {
      setPasswordSaving(false);
    }
  }

  function handlePasswordCancel() {
    resetPasswordState();
    setShowPasswordForm(false);
  }

  return (
    <section className="account-page">
      <header className="account-header">
        <h1>My Account</h1>
        {/* <button
          className="pill-btn green"
          onClick={() => setShowPasswordForm((prev) => !prev)}
          type="button"
        >
          🔒 Update Password
        </button> */}
      </header>

      <div className="account-card">
        <div className="account-card-head">
          <h3>Account Information</h3>
        </div>
        <div className="account-info-table">
          {info.map((row) => (
            <div key={row.label} className="account-info-row">
              <div className="account-info-label">{row.label}</div>
              <div className="account-info-value">{row.value || "—"}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="account-card">
        <div className="account-card-head">
          <h3>Edit Account Information</h3>
        </div>
        <form className="account-form" onSubmit={handleSubmit}>
          <div className="account-form-row">
            <label>Email: *</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              required
            />
          </div>
          <div className="account-form-row">
            <label>Contact Person: *</label>
            <input
              type="text"
              value={form.contactPerson}
              onChange={(e) => setForm((f) => ({ ...f, contactPerson: e.target.value }))}
              required
            />
          </div>
          <div className="account-form-row">
            <label>Company: *</label>
            <input
              type="text"
              value={form.companyName}
              onChange={(e) => setForm((f) => ({ ...f, companyName: e.target.value }))}
              required
            />
          </div>
          <div className="account-form-row">
            <label>Address:</label>
            <input
              type="text"
              value={form.address}
              onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))}
            />
          </div>
          <div className="account-form-row">
            <label>Country:</label>
            <input
              type="text"
              value={form.country}
              onChange={(e) => setForm((f) => ({ ...f, country: e.target.value }))}
            />
          </div>
          <div className="account-form-row">
            <label>City:</label>
            <input
              type="text"
              value={form.city}
              onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
            />
          </div>
          <div className="account-form-row">
            <label>Phone:</label>
            <input
              type="text"
              value={form.phone}
              onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
            />
          </div>
          <div className="account-form-row">
            <label>Website:</label>
            <input
              type="url"
              value={form.appWebsiteLink}
              onChange={(e) => setForm((f) => ({ ...f, appWebsiteLink: e.target.value }))}
            />
          </div>
          <div className="account-form-row">
            <label>Notifications Email Address:</label>
            <input
              type="email"
              value={form.notificationsEmail}
              onChange={(e) => setForm((f) => ({ ...f, notificationsEmail: e.target.value }))}
            />
          </div>

          {error && <p className="account-form-error">{error}</p>}
          {success && <p className="account-form-success">{success}</p>}

          <button className="pill-btn green small" type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </form>
      </div>

      <div className="account-card">
        <div className="account-card-head">
          <h3>Update Password</h3>
        </div>
        <form className="account-form" onSubmit={handlePasswordSubmit}>
          <div className="account-form-row">
            <label>Current Password: *</label>
            <input
              type="password"
              value={passwordForm.current}
              onChange={(e) => setPasswordForm((f) => ({ ...f, current: e.target.value }))}
              required
            />
          </div>
          <div className="account-form-row">
            <label>New Password: *</label>
            <input
              type="password"
              value={passwordForm.next}
              onChange={(e) => setPasswordForm((f) => ({ ...f, next: e.target.value }))}
              required
            />
          </div>
          <div className="account-form-row">
            <label>Confirm New Password: *</label>
            <input
              type="password"
              value={passwordForm.confirm}
              onChange={(e) => setPasswordForm((f) => ({ ...f, confirm: e.target.value }))}
              required
            />
          </div>

          {passwordError && <p className="account-form-error">{passwordError}</p>}
          {passwordSuccess && <p className="account-form-success">{passwordSuccess}</p>}

          <div className="account-form-actions">
            <button className="pill-btn green" type="submit" disabled={passwordSaving}>
              {passwordSaving ? 'Saving...' : 'Save'}
            </button>
            <button className="pill-btn grey" type="button" onClick={handlePasswordCancel}>
              ✕ Cancel
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
